/**
 * Textos do card "Preparação do pacote" (E168.F7, GUS-180, ADR-0116 §9), na pré-análise e na mesa
 * eletrônicas. É material da equipe: o cliente só recebe o laudo final, nunca a prévia.
 *
 * E170.F2 (GUS-229): a jornada de cada saída — gerado, bloqueado na conferência, aguardando revisão,
 * revisado, assinado e entregue — e o caminho da correção.
 *
 * E172.F19 (GUS-230 item 5): a prévia em atualização — o botão espera e diz por quê.
 *
 * E180.F3 (GUS-254): a falha do processamento com a retomada automática e a prévia com o banco
 * pendente.
 */
export const ptBRPacote = {
  titulo: 'Preparação do pacote',
  // E207.F5.T03: a linha "Pacote completo · Ver o pacote" da mesa saiu (o botão "Exame" dá o ZIP).
  carregando: 'Lendo a preparação do pacote…',
  erro: 'Não foi possível ler a preparação do pacote. Tente novamente.',
  semPermissao: 'A preparação do pacote é da equipe que atende o caso.',
  naoEncontrado: 'Caso não encontrado.',
  tentarDeNovo: 'Tentar de novo',
  versao: 'Versão {versao} da análise',
  modo: {
    parte: 'modo PARTE',
    juizo: 'modo JUÍZO',
  },
  preparando: 'Preparando agora. Esta área se atualiza sozinha.',
  // E200.F2 (GUS-220, ADR-0143 §1): a etapa em curso, nomeada; sem contagem inventada.
  preparandoEtapa: 'Preparando agora: {etapa}. Esta área se atualiza sozinha.',
  etapaDaPreparacao: {
    aguardando_vaga: 'aguardando a vez',
    processamento: 'analisando o material',
    saidas: 'compondo as prévias',
    leituras: 'lendo os documentos',
  },
  // E200.F2: a progressão do caso no card — concluída, atual, a fazer ou falhou.
  etapas: {
    titulo: 'Etapas do caso',
    documentos: 'Documentos',
    leitura: 'Leitura',
    analise: 'Análise',
    previas: 'Prévias',
    revisao: 'Revisão',
    assinatura: 'Assinatura',
    entrega: 'Entrega',
    situacaoDaEtapa: {
      concluida: 'concluída',
      atual: 'em andamento',
      // E206.F4 (GUS-296 item 5): a etapa atual com nada rodando (o caso parado) não está "em
      // andamento": é a próxima a fazer.
      atualParada: 'próxima a fazer',
      pendente: 'a fazer',
      falhou: 'falhou',
    },
  },
  // E200.F2 (ADR-0143 §2): a marca na coluna Situação da lista de casos.
  naLista: {
    preparando: 'Preparando · {etapa}',
    falhou: 'Falha na preparação',
  },
  completo:
    'Pacote completo: o exame desta versão está preparado e aprovado pela conferência por regras.',
  incompleto: 'Pacote incompleto.',
  bloqueado: {
    um: 'Pacote incompleto: {saidas} não passou na conferência por regras. Corrija antes da revisão.',
    varios:
      'Pacote incompleto: {saidas} não passaram na conferência por regras. Corrija antes da revisão.',
  },
  entregue: 'Entregue ao cliente: o laudo assinado desta versão está disponível.',
  entregueJuizo: 'Entregue ao cliente: o laudo assinado desta versão está disponível.',
  entregaIncompleta: 'Entrega pendente: o laudo está assinado e ainda não foi entregue ao cliente.',
  semCertificado:
    'Assinado por registro na plataforma, sem certificado digital ICP-Brasil: o pacote fica com a equipe e não é entregue ao cliente.',
  jornada: {
    gerado: 'Gerado, sem conferência',
    bloqueado: 'Bloqueado na conferência',
    aguardando_revisao: 'Aguardando revisão',
    revisado: 'Revisado',
    assinado: 'Assinado',
    entregue: 'Entregue ao cliente',
  },
  reprovados: 'Não passou na conferência por regras: {criterios}.',
  // E184.F4 (GUS-145 item 6, ADR-0136 §5): a regra e o trecho que a reprovou, com o atalho.
  trechoReprovado: {
    comTrecho: '{regra}, no trecho “{trecho}”',
    semTrecho: '{regra}: {no_documento}',
    abrir: 'Abrir este trecho na mesa',
  },
  // E184.F1 (GUS-145 item 1, ADR-0136 §1): as edições salvas numa análise anterior seguem na nova;
  // o perito confere na mesa antes de revisar.
  herdadas: {
    uma: 'Uma edição salva numa análise anterior segue nesta versão.',
    varias: '{n} edições salvas numa análise anterior seguem nesta versão.',
    conferir: 'Conferir na mesa',
  },
  irParaAConferencia: 'Para corrigir: Conferir laudo e orientações',
  linha: {
    documentos: 'Documentos e fontes',
    analise: 'Análise',
    exame: 'Exame',
    riscos: 'Relatório de risco',
  },
  estado: {
    pronto: 'Pronto',
    em_andamento: 'Em preparação',
    aguardando: 'Aguardando',
    bloqueado: 'Bloqueado',
    falhou: 'Falhou',
    nao_se_aplica: 'Não se aplica',
  },
  recebidos: {
    um: '1 documento recebido',
    varios: '{n} documentos recebidos',
  },
  // E216.F3.C03 (GUS-317 4b): com a prévia do exame, a conta da seção 2
  examinados: {
    um: '1 documento examinado',
    varios: '{n} documentos examinados',
  },
  tentativas: '{n} tentativas nesta versão',
  naoSeAplica: 'Em JUÍZO não há relatório de risco.',
  motivo: {
    composicao_falhou: 'A composição do documento não terminou.',
    conversao_falhou: 'A conversão para PDF não terminou.',
    gravacao_falhou: 'A gravação do arquivo não terminou.',
    interrompida: 'A preparação parou antes de terminar.',
    leitura_em_andamento: 'Leitura dos documentos em andamento.',
    analise_facial_em_andamento: 'Análise morfológica facial em andamento.',
    // E216.F4.C02 (GUS-317 3b): nunca "Aguardando" sem motivo
    cadastro_nao_concluido:
      'O cadastro deste caso não foi concluído: a análise e as prévias começam depois de "Enviar e seguir".',
    sem_avaliacao: 'A análise ainda não foi gerada.',
    busca_nao_conferida: 'A busca nos documentos ainda não foi conferida.',
    sem_ator: 'Sem responsável para registrar a preparação.',
    versao_nova: 'A análise mudou: a versão nova está sendo preparada.',
    liberacao_pendente: 'O laudo foi assinado: o relatório de risco final está sendo liberado.',
    reservado_nao_conferido:
      'O relatório de risco final não passou na conferência por regras e não foi liberado.',
    instituicao_nao_cadastrada:
      'O caso não tem a instituição cadastrada: cadastre o banco do caso e retome a liberação do relatório de risco final.',
    assinatura_sem_certificado:
      'Assinado por registro na plataforma, sem certificado digital ICP-Brasil: o cliente não recebe esta saída.',
    // E180.F3 (GUS-254 item 1): a falha do processamento, com a retomada automática.
    processamento_falhou: 'O processamento do material parou por uma falha técnica.',
  },
  avisoDaFalha:
    '{saida} não foi preparado por uma falha técnica. O que já está pronto segue válido; retome só o que falhou.',
  avisoDaAnalise:
    'A análise parou {etapa} por uma falha técnica ({causa}). O sistema retoma sozinho em instantes, sem ação na mesa; o que já estava pronto segue válido.',
  // E180.F3.C02 (F-E180.F3-03): a etapa em que a rodada parou e a causa, sem detalhe interno.
  etapaDaFalha: {
    processamento: 'no processamento do material',
    saidas: 'na escolha das prévias a preparar',
    leituras: 'na leitura dos documentos',
  },
  causaDaFalha: {
    registros: 'leitura ou gravação dos registros do caso',
    arquivo: 'leitura ou gravação de arquivo',
    tempo_esgotado: 'tempo de resposta esgotado',
    inesperada: 'erro inesperado',
  },
  bancoPendente:
    'Banco pendente: as prévias estão prontas para leitura. A revisão e a emissão final esperam o banco do caso; informar o banco refaz as duas prévias.',
  avisoDaLiberacao:
    'O relatório de risco final não foi liberado. O laudo assinado segue válido e não é assinado de novo; retome a liberação.',
  previa: 'Prévia: proposta do sistema, ainda não revisada pelo perito.',
  consultar: 'Baixar a prévia',
  baixarFinal: 'Baixar o arquivo final',
  baixando: 'Baixando…',
  erroAoBaixar: 'Não foi possível baixar a prévia. Atualize a área e tente de novo.',
  // E196.F1 (GUS-260): o exame e os arquivos recebidos num ZIP, antes da assinatura.
  exameEArquivos: {
    baixar: 'Baixar exame e arquivos (ZIP)',
    // E216.F5 (GUS-317 item 7): só o que a seção 2 do exame relaciona, com os recibos
    dica: 'O exame, o manifesto de cada recebimento e os arquivos que a seção 2 do exame relaciona, com o PDF de origem das imagens tiradas de página.',
    erro: 'Não foi possível baixar o exame e os arquivos. Atualize a área e tente de novo.',
    arquivos:
      'Um arquivo que o exame relaciona não confere com o registro do recebimento, não está guardado ou não foi localizado, e o pacote não foi gerado.',
  },
  atualizando: 'Atualizando…',
  avisoDeAtualizacao:
    'A prévia está sendo refeita com a análise mais recente. A anterior não vale para ela; o download volta quando terminar.',
  passo: 'Para seguir: {passo}',
  retomar: 'Retomar',
  formulario: {
    rotulo: 'Motivo da retomada',
    dica: 'De {min} a {max} caracteres. Fica registrado em seu nome.',
    enviar: 'Retomar a preparação',
    enviando: 'Pedindo…',
    cancelar: 'Cancelar',
    pedida: 'Retomada pedida. A área se atualiza quando terminar.',
  },
  recusa: {
    em_andamento: 'Uma preparação deste caso já está em andamento. Aguarde terminar.',
    nao_retomavel: 'Esta saída não está mais para retomar. A área foi atualizada.',
    justificativa: 'Escreva o motivo com {min} a {max} caracteres.',
    indisponivel: 'Não foi possível pedir a retomada agora. Tente novamente.',
  },
} as const;
